import {giveTextColorForBackGroundColor} from "@/util/ColorUtil";

const VACATION_FULL_DAY = {
    type: "VACATION_FULL_DAY",
    absenceCategory: "VACATION",
    fullDay: true,
    allDay: true, // distinct from fullDay needed for callender plugin always true
    color: "orange",
    textColor: giveTextColorForBackGroundColor("orange"),
    title: "Vakantie volledige dag"
};

const VACATION_HALF_DAY = {
    type: "VACATION_HALF_DAY",
    absenceCategory: "VACATION",
    fullDay: false,
    allDay: true, // distinct from fullDay needed for callender plugin always true
    color: "orange",
    textColor: giveTextColorForBackGroundColor("orange"),
    title: "Vakantie halve dag"
};

const SICK_LEAVE_FULL_DAY = {
    type: "SICK_LEAVE_FULL_DAY",
    absenceCategory: "SICK_LEAVE",
    fullDay: true,
    allDay: true, // distinct from fullDay needed for callender plugin always true
    color: "black",
    textColor: giveTextColorForBackGroundColor("black"),
    title: "Ziek volledige dag"
};

const SICK_LEAVE_HALF_DAY = {
    type: "SICK_LEAVE_HALF_DAY",
    absenceCategory: "SICK_LEAVE",
    fullDay: false,
    allDay: true, // distinct from fullDay needed for callender plugin always true
    color: "black",
    textColor: giveTextColorForBackGroundColor("black"),
    title: "Ziek halve dag"
};

const RECUPERATION_FULL_DAY = {
    type: "RECUPERATION_FULL_DAY",
    absenceCategory: "RECUPERATION",
    fullDay: true,
    allDay: true, // distinct from fullDay needed for callender plugin always true
    color: "purple",
    textColor: giveTextColorForBackGroundColor("purple"),
    title: "Recup volledige dag"
};

const RECUPERATION_HALF_DAY = {
    type: "RECUPERATION_HALF_DAY",
    absenceCategory: "RECUPERATION",
    fullDay: false,
    allDay: true, // distinct from fullDay needed for callender plugin always true
    color: "purple",
    textColor: giveTextColorForBackGroundColor("purple"),
    title: "Recup halve dag"
};

const RECUPERATION_HOLIDAY = {
    type: "REPLACEMENT_HOLIDAY_FULL_DAY",
    absenceCategory: "RECUPERATION_HOLIDAY",
    fullDay: true,
    allDay: true, // distinct from fullDay needed for callender plugin always true
    color: "purple",
    textColor: giveTextColorForBackGroundColor("purple"),
    title: "Feestdag recup"
};

const EXCUSED_ABSENCE_FULL_DAY = {
    type: "EXCUSED_ABSENCE_FULL_DAY",
    absenceCategory: "EXCUSED_ABSENCE",
    fullDay: true,
    allDay: true,
    color: "lime",
    textColor: giveTextColorForBackGroundColor("lime"),
    title: "Klein verlet volledige dag"
};

const EXCUSED_ABSENCE_HALF_DAY = {
    type: "EXCUSED_ABSENCE_HALF_DAY",
    absenceCategory: "EXCUSED_ABSENCE",
    fullDay: false,
    allDay: true,
    color: "lime",
    textColor: giveTextColorForBackGroundColor("lime"),
    title: "Klein verlet halve dag"
};

const PERSONAL_LEAVE_FULL_DAY = {
    type: "PERSONAL_LEAVE_FULL_DAY",
    absenceCategory: "PERSONAL_LEAVE",
    fullDay: true,
    allDay: true,
    color: "teal",
    textColor: giveTextColorForBackGroundColor("teal"),
    title: "Familiaal verlof volledige dag"
};

const PERSONAL_LEAVE_HALF_DAY = {
    type: "PERSONAL_LEAVE_HALF_DAY",
    absenceCategory: "PERSONAL_LEAVE",
    fullDay: false,
    allDay: true,
    color: "teal",
    textColor: giveTextColorForBackGroundColor("teal"),
    title: "Familiaal verlof halve dag"
};

const EDUCATIONAL_LEAVE_FULL_DAY = {
    type: "EDUCATIONAL_LEAVE_FULL_DAY",
    absenceCategory: "EDUCATIONAL_LEAVE",
    fullDay: true,
    allDay: true,
    color: "teal",
    textColor: giveTextColorForBackGroundColor("teal"),
    title: "Vlaams Opleidingsverlof volledige dag"
};

const EDUCATIONAL_LEAVE_HALF_DAY = {
    type: "EDUCATIONAL_LEAVE_HALF_DAY",
    absenceCategory: "EDUCATIONAL_LEAVE",
    fullDay: false,
    allDay: true,
    color: "teal",
    textColor: giveTextColorForBackGroundColor("teal"),
    title: "Vlaams Opleidingsverlof halve dag"
};

const SICK_LEAVE_NO_CERTIFICATE_FULL_DAY = {
    type: "SICK_LEAVE_NO_CERTIFICATE_FULL_DAY",
    absenceCategory: "SICK_LEAVE_NO_CERT",
    fullDay: true,
    allDay: true,
    color: "black",
    textColor: giveTextColorForBackGroundColor("black"),
    title: "Ziek volledige dag"
};

const SICK_LEAVE_NO_CERTIFICATE_HALF_DAY = {
    type: "SICK_LEAVE_NO_CERTIFICATE_HALF_DAY",
    absenceCategory: "SICK_LEAVE_NO_CERTIFICATE",
    fullDay: false,
    allDay: true,
    color: "black",
    textColor: giveTextColorForBackGroundColor("black"),
    title: "Ziek halve dag"
};

const UNPAID_LEAVE_FULL_DAY = {
    type: "UNPAID_LEAVE_FULL_DAY",
    absenceCategory: "UNPAID_LEAVE",
    fullDay: true,
    allDay: true,
    color: "#B76E79",
    textColor: giveTextColorForBackGroundColor("#B76E79"),
    title: "Onbetaald verlof"
};

const UNPAID_LEAVE_HALF_DAY = {
    type: "UNPAID_LEAVE_HALF_DAY",
    absenceCategory: "UNPAID_LEAVE",
    fullDay: false,
    allDay: true,
    color: "#B76E79",
    textColor: giveTextColorForBackGroundColor("#B76E79"),
    title: "Onbetaald verlof"
};

const DAILY_ABSENCE_PROLONGED_SICK_LEAVE_FULL_DAY = {
    type: "DAILY_ABSENCE_PROLONGED_SICK_LEAVE_FULL_DAY",
    absenceCategory: "DAILY_ABSENCE_PROLONGED_SICK_LEAVE",
    fullDay: true,
    allDay: true,
    color: "#ffd000",
    textColor: giveTextColorForBackGroundColor("#ffd000"),
    title: "Ziekte voor langdurige zieken"
};

export const vacationList = [
    VACATION_FULL_DAY,
    VACATION_HALF_DAY,
    RECUPERATION_FULL_DAY,
    RECUPERATION_HALF_DAY,
    RECUPERATION_HOLIDAY,
    EDUCATIONAL_LEAVE_FULL_DAY,
    EDUCATIONAL_LEAVE_HALF_DAY
];

export const sickLeaveList = [
    SICK_LEAVE_FULL_DAY,
    SICK_LEAVE_HALF_DAY,
    SICK_LEAVE_NO_CERTIFICATE_FULL_DAY,
    SICK_LEAVE_NO_CERTIFICATE_HALF_DAY,
    DAILY_ABSENCE_PROLONGED_SICK_LEAVE_FULL_DAY,
];

const absenceList = [
    ...vacationList, ...sickLeaveList
];

const absenceListAdmin = [
    ...vacationList,
    ...sickLeaveList,
    EXCUSED_ABSENCE_FULL_DAY,
    EXCUSED_ABSENCE_HALF_DAY,
    PERSONAL_LEAVE_FULL_DAY,
    PERSONAL_LEAVE_HALF_DAY,
    UNPAID_LEAVE_FULL_DAY,
    UNPAID_LEAVE_HALF_DAY
];

const vacationTypes = [
    'STATUTORY_VACATION',
    'TRANSFER_HOLIDAY_PREVIOUS_YEAR',
    'EXTRA_VACATION_PREVIOUS_YEAR',
    'SENIORITY_LEAVE',
    'ADDITIONAL_HOLIDAY_EMPLOYEE',
    'SENIOR_VACATION',
    'YOUTH_VACATION',
    'EXTRA_VACATION_CURRENT_YEAR',
    'JOB_APPLICATION_LEAVE'
];

export const typeToAbsenceObject = {};
absenceList.forEach(absence => {
    typeToAbsenceObject[absence.type] = absence;
});

export const typeToAbsenceObjectAdmin = {};
absenceListAdmin.forEach(absence => {
    typeToAbsenceObjectAdmin[absence.type] = absence;
});

export const titleToAbsenceObject = {};
absenceList.forEach(absence => {
    titleToAbsenceObject[absence.title] = absence;
});

export const isVacation = (absence) => {
    return absence.absenceCategory === "VACATION";
};

export const isSickness = (absence) => {
    return absence.absenceCategory === "SICK_LEAVE" || absence.absenceCategory === "SICK_LEAVE_NO_CERT";
};

export const isRecup = (absence) => {
    return absence.absenceCategory === "RECUPERATION";
};

export const isExcusedAbsence = (absence) => {
    return absence.absenceCategory === "EXCUSED_ABSENCE";
};

export const isPersonalLeave = (absence) => {
    return absence.absenceCategory === "PERSONAL_LEAVE";
};

export const isUnpaidLeave = absence => {
    return absence.absenceCategory === "UNPAID_LEAVE";
};

export const isHalfDayEvent = (absence) => {
    return !absence.fullDay;
};

export const toAbsenceObject = (absenceDto) => {
    let absenceCategory;
    if (vacationTypes.includes(absenceDto.absenceType.vacationCategory)) {
        absenceCategory = 'VACATION';
    } else if(absenceDto.absenceType.absenceCategory === "EDUCATIONAL_LEAVE") {
        absenceCategory = 'EDUCATIONAL_LEAVE';
    } else if (absenceDto.absenceType.absenceCategory === "RECUPERATION_HOLIDAY") {
        return RECUPERATION_HOLIDAY;
    } else {
        absenceCategory = absenceDto.absenceType.absenceCategory;
    }
    return typeToAbsenceObjectAdmin[absenceCategory + getSuffixForAbsenceType(absenceDto.hours)];
};

const getSuffixForAbsenceType = (hours) => {
    return hours >= 7.6 ? '_FULL_DAY' : '_HALF_DAY';
};